import { CommonModule, Location } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { BreadcrumbComponent } from '@merchant-portal/app/components/breadcrumb/breadcrumb.component';
import { MobileHeaderStore } from './store/mobile-header.state';

@Component({
  selector: 'app-mobile-detail-header',
  templateUrl: './mobile-detail-header.component.html',
  styleUrls: ['./mobile-detail-header.component.scss'],
  imports: [CommonModule],
})
export class MobileDetailHeaderComponent implements OnInit, OnDestroy {
  @Input() title: string = '';
  @Input() showDownload: boolean = false;
  @Input() downloadDisabled: boolean = false;
  @Input() showAdd: boolean = false;
  @Input() addDisabled: boolean = false;
  @Input() disableDefaultBack: boolean = false;
  @Input() breadcrumb?: BreadcrumbComponent;
  @Output() back = new EventEmitter<void>();
  @Output() download = new EventEmitter<void>();
  @Output() add = new EventEmitter<void>();

  constructor(private location: Location) {}

  ngOnInit() {
    MobileHeaderStore.setHideMainHeader(true);
  }

  ngOnDestroy() {
    MobileHeaderStore.setHideMainHeader(false);
  }

  onBack() {
    this.back.emit();
    if (!this.disableDefaultBack) {
      this.location.back();
    }
  }

  onDownload() {
    this.download.emit();
  }

  onAdd() {
    this.add.emit();
  }
}
